<template>
  <el-select
    v-model="value"
    popper-append-to-body
    :loading="isLoading"
    :placeholder="placeholder"
    :disabled="disabled"
    @change="handlerChange"
    :clearable="clearable"
    filterable
    :multiple-limit="multipleLimit"
    :multiple="multiple"
    :size="size"
    :filter-method="filterMethod"
    @focus="handlerFocus"
    @paste.native="handlePaste"
    ref="select">
    <template v-slot:prefix>
      <slot name="prefix">
      </slot>
    </template>
    <slot name="select-info" />
    <el-option
      v-for="item in showedData"
      :key="item[fields.id]"
      :label="getLabel(item)"
      :value="item[fields.id]"
      :disabled="!!item.disabled"
    >
    </el-option>
  </el-select>
</template>

<script>
import { select } from './mixins'
export default {
  name: 'Desktop',
  mixins: [select]
}
</script>
